// Actions
import * as actions from '../reducers/modal/modalActions';

export const ModalMiddlewareListeners = {
  [actions.MODAL_TOGGLE]: (
    { dispatch, getState },
    { payload: { activeModal, data } }
  ) => {
    const { modal } = getState();
    modal.activeModal === activeModal
      ? dispatch(actions.closeModal(activeModal, data))
      : dispatch(actions.openModal(activeModal, data));
  },
  [actions.MODAL_OPEN]: (store, { payload }) => {
    if (window.innerWidth < 600)
      payload.scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
    if (typeof payload.onOpen === 'function') payload.onOpen();
  },
  [actions.MODAL_CLOSE]: (store, { payload }) => {
    // const { modal } = getState();
    if (typeof payload.onClose === 'function') payload.onClose();
    // if (modal.scrollTop) {
    //   let meta = { scrollTop: modal.scrollTop };
    // }
  },
};

const ModalMiddleware = store => next => action => {
  next(action);
  if (ModalMiddlewareListeners[action.type])
    return ModalMiddlewareListeners[action.type](store, action);
};

export default ModalMiddleware;
